import { useCallback } from "react";
import { useLazyQuery } from "@apollo/client";
import { QUERY_ACTIVE_OCA_TEMPLATE } from "../insurance/api";

export function useOCATemplates() {
  const [fetchActiveOcaTemplate, { loading: isOCATEmplatesLoading }] = useLazyQuery(QUERY_ACTIVE_OCA_TEMPLATE, {
    fetchPolicy: "no-cache",
  });

  const handleCheckAvailableTemplates = useCallback(
    async (vpId: string) => {
      const { data } = await fetchActiveOcaTemplate({
        variables: {
          vendorProfileId: vpId,
          isActive: true,
        },
      });

      return {
        templates: data?.getOcaTemplatesByVendorProfile,
        isTemplatesExist: !!(data?.getOcaTemplatesByVendorProfile ?? []).length,
      };
    },
    [fetchActiveOcaTemplate]
  );

  return {
    handleCheckAvailableTemplates,
    isLoading: isOCATEmplatesLoading,
  };
}
